import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoginForm } from '../components/LoginForm';
import { RegisterForm } from '../components/RegisterForm';
import { LoadingSpinner } from '../components/LoadingSpinner';
import './AuthPage.css';

type AuthMode = 'login' | 'register';

export function AuthPage() {
  const [mode, setMode] = useState<AuthMode>('login');
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user, isLoading } = useAuth();

  // 이미 로그인된 경우 역할별 기본 페이지로 리디렉션
  React.useEffect(() => {
    if (isAuthenticated && user) {
      // 역할별로 적절한 페이지로 리다이렉션
      if (user.role === 'collector') {
        navigate('/sslmo/collector/dashboard', { replace: true });
      } else if (user.role === 'admin') {
        navigate('/sslmo/admin', { replace: true });
      } else {
        navigate('/sslmo/dashboard', { replace: true });
      }
    }
  }, [isAuthenticated, user, navigate]);

  // 로딩 중일 때 로딩 화면 표시
  if (isLoading) {
    return (
      <div className="auth-page">
        <div className="loading-container">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  // 이미 인증된 사용자는 위의 useEffect에서 리다이렉션되므로 
  // 여기서는 빈 화면을 잠깐 보여줌
  if (isAuthenticated) {
    return (
      <div className="auth-page">
        <div className="loading-container">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  // LoginForm에서 직접 리다이렉션을 처리하므로 빈 함수로 변경
  const handleAuthSuccess = () => {
    // LoginForm이 직접 처리함
  };

  const switchToLogin = () => setMode('login');
  const switchToRegister = () => setMode('register');

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>SSLMO</h1>
          <p>폐기물 수거 관리 서비스</p>
        </div>
        
        {mode === 'login' ? (
          <LoginForm
            onSuccess={handleAuthSuccess}
            onSwitchToRegister={switchToRegister}
          />
        ) : (
          <RegisterForm
            onSuccess={handleAuthSuccess}
            onSwitchToLogin={switchToLogin}
          />
        )}
      </div>
    </div>
  );
}